export {
  IndirectTaxJurisdictionType,
  TIndirectTaxRegistrationStatus,
  // V2 types
  type IIndirectTaxRegistrationV2Response,
  type IIndirectTaxRegistrationV2WithSettings,
} from '@commenda/api/indirect-tax/registrations/types';

export enum IndirectTaxRegistrationTab {
  DETAILS = 'DETAILS',
  COMPANY_DETAILS = 'COMPANY_DETAILS',
  ACTIVITY = 'ACTIVITY',
  SETTINGS = 'SETTINGS',
  FILINGS = 'FILINGS',
  LOCAL_REGISTRATIONS = 'LOCAL_REGISTRATIONS',
}

/** Locks the region and restricts registrations when a flow opens from an exposure row. */
export interface IndirectTaxRegistrationExposurePrefill {
  jurisdictionId: string;
  jurisdictionDisplayName: string;
  jurisdictionISOCode: string;
  recommendedRegistrationContentIds: string[];
}

export enum IndirectTaxRegistrationTableFilter {
  JURISDICTION = 'JURISDICTION',
  TAX_TYPE = 'TAX_TYPE',
  FILING_FREQUENCY = 'FILING_FREQUENCY',
  TAX_CALCULATION = 'TAX_CALCULATION',
  MANAGED_FILING = 'MANAGED_FILING',
}

export interface IndirectTaxRegistrationFiling {
  id: string;
  returnType: string;
  status: 'Active' | 'Filed' | 'Overdue';
  period: string;
  dueDate: string;
  currency: string;
  amount: number;
}

